import { IModel } from './imodel';

export class Building implements IModel {

    IdObject: any;

    Id: number;

    Site: string;

    SiteId: number;

    Address: string;

    Designation: string;

    Directions: string;

    Location: string;

    ShortName: string;

    Zip: string;

    Url: string;

    static create(object: Building): Building {
        const instance = new Building();
        instance.IdObject = object.IdObject;
        instance.Id = object.Id;
        instance.Site = object.Site;
        instance.SiteId = object.SiteId;
        instance.Address = object.Address;
        instance.Designation = object.Designation;
        instance.Location = object.Location;
        instance.ShortName = object.ShortName;
        instance.Zip = object.Zip;
        instance.Url = object.Url;
        return instance;
    }
}
